<template>
  <div class="outDiv">
    <div class="searchBar">
      <div class="searchLeft">
        <el-popover placement="right-bottom" title="条件检索" trigger="click" v-model="searchVisible">
          <searchForm @startSearch="handleTableSearch" @cancleSearch="handleCancleSeach"></searchForm>
          <el-button slot="reference" size="mini">按条件筛选</el-button>
        </el-popover>
        <navTopTag :searchTagList="searchTagList" @handleDelOne="handleDelOne"></navTopTag>
      </div>
    </div>
    <div>
      <!-- <el-tabs v-model="allTableObj.currentTab" @tab-click="tabClick($event)">
        <el-tab-pane
          label="所有记录"
          name="all"
          ref="all"
          id="allTab"
        ></el-tab-pane>
        <el-tab-pane label="搜索结果" name="search"></el-tab-pane>
      </el-tabs> -->
      <div class="tableContainer">
        <baseTable :columns="allTableObj.columns" :dataList="allTableObj.dataList" :options="allTableObj.options"
          :loadObj="allTableObj.loadObj" :operationColumn="allTableObj.operationColumn" :fenyeObj="allTableObj.fenyeObj"
          @dataSizeChange="handleSizeChange($event, allTableObj)"
          @dataCurrentChange="handleCurrentChange($event, allTableObj)"></baseTable>
      </div>
    </div>
  </div>
</template>
<script>
import { callRecordApi } from "@/services/all-api.js";
import searchForm from "./search-form.vue";

export default {
  components: {
    searchForm,
  },
  data() {
    return {
      searchTagList: [],
      searchVisible: false,
      allTableObj: {
        columns: [
          {
            prop: "num",
            label: "#",
            width: "50px",
            align: "center",
          },
          {
            prop: "callingNumber",
            label: "主叫号码",
            align: "center",
          },
          {
            prop: "calledNumber",
            label: "被叫号码",
            align: "center",
          },
          {
            prop: "agentNames",
            label: "座席名称",
            align: "center",
          },
          {
            prop: "contactDisposition",
            label: "接听状态",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {},
                params.row.contactDisposition === "Success"
                  ? "正常"
                  : params.row.contactDisposition === "NoAnswer"
                  ? "无应答"
                  : params.row.contactDisposition === "Rejected"
                  ? "拒绝"
                  : params.row.contactDisposition === "Busy"
                  ? "忙"
                  : params.row.contactDisposition ===
                    "AbandonedInContactFlow IVR"
                  ? "呼损"
                  : params.row.contactDisposition === "AbandonedInQueue"
                  ? "队列呼损"
                  : params.row.contactDisposition === "AbandonedRing"
                  ? "久振不接"
                  : params.row.contactDisposition === "QueueOverflow"
                  ? "等待超时被挂断"
                  : ""
              );
            },
          },
          {
            prop: "contactType",
            label: "呼叫类型",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {},
                params.row.contactType === "Inbound" ? "呼入" : "呼出"
              );
            },
          },
          {
            prop: "recordingDuration",
            label: "通话时长",
            align: "center",
            render: (h, params) => {
              return h("span", {}, params.row.recordingDuration + "秒");
            },
          },
          {
            prop: "startTime",
            label: "开始时间",
            align: "center",
          },
          {
            prop: "endTime",
            label: "结束时间",
            align: "center",
          },
          // {
          //   prop: "isBaseInfoPerfect",
          //   label: "基础信息",
          //   align: "center",
          //   render: (h, params) => {
          //     return h("span", { style: params.row.isBaseInfoPerfect === true ? "color:#67C23A" : "color:#E6A23C" }, params.row.isBaseInfoPerfect === true ? "已完善" : "未完善")
          //   }
          // },
        ],
        dataList: [],
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead,
        },
        loadObj: {
          isLoading: false,
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0,
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0,
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "200px",
          btns: [
            {
              size: "mini",
              icon: "el-icon-tickets",
              type: "text",
              style: "font-size:16px",
              disabled: false,
              method: (index, row) => {
                this.handleDetail(index, row);
              },
            },
          ],
        },
        fenyeObj: {
          showPage: true,
          currentPage: 1,
          pageSize: 20,
          layoutString: "total,sizes,prev,pager,next,jumper",
          total: 0,
        },
        currentTab: "all",
        searchObj: {},
      },
    };
  },
  methods: {
    timestampToTime(dateTemp) {
      var date = new Date(dateTemp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      var strDate = Y + M + D + h + m + s;
      return strDate;
    },
    loadData(obj) {
      obj.loadObj.isLoading = true;
      let endTime = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      //   endtime默认当前，starttime默认7天前
      callRecordApi
        .getList({
          size: obj.allDataNow.pageSize,
          index: obj.allDataNow.currentPage - 1,
          endtime: this.Utils.dateFormat(endTime, "YYYY-MM-DD"),
          starttime: this.Utils.dateFormat(
            new Date(endTime.getTime() - 168 * 60 * 60 * 1000),
            "YYYY-MM-DD"
          ),
        })
        .then((res) => {
          if (res.code === 0) {
            //先缓存
            obj.allDataNow.dataList = res.data.map((o, i) => ({
              ...o,
              num: res.index * res.size + i + 1,
            }));
            obj.allDataNow.total = res.total;
            //最后赋值  默认全部
            obj.dataList = res.data.map((o, i) => {
              let a = {
                ...o,
                startTime: this.timestampToTime(o.startTime),
                endTime: this.timestampToTime(
                  o.startTime + o.callDuration * 1000
                ),
                establishedTime: o.establishedTime
                  ? this.timestampToTime(o.establishedTime)
                  : "-",
                releaseTime: o.releaseTime
                  ? this.timestampToTime(o.releaseTime)
                  : "-",
                num: res.index * res.size + i + 1,
              };
              return a;
            });
            obj.fenyeObj.total = res.total;
          } else {
            this.$message.error(`请求失败：${res.des}`);
          }
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    //每次页面码数变了 要变回第一页
    handleSizeChange(i, obj) {
      let reqObj = {};
      if (obj.currentTab == "all") {
        obj.allDataNow.currentPage = 1;
        obj.allDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
        };
      } else if (obj.currentTab == "search") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          ...this.$store.state.currentSearchForm,
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCurrentChange(i, obj) {
      let reqObj = {};
      let flag = obj.currentTab;
      if (flag == "all") {
        obj.allDataNow.currentPage = i;
        obj.allDataNow.pageSize = obj.allDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.allDataNow.pageSize,
        };
      } else if (flag == "search") {
        obj.searchDataNow.currentPage = i;
        obj.searchDataNow.pageSize = obj.searchDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.searchDataNow.pageSize,
          ...this.$store.state.currentSearchForm,
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleTableSearch(i) {
      this.searchVisible = i.searchShow;
      this.searchTagList = this.getTagList(
        this.getRecordSearch(),
        i.searchData
      );
      this.$store.commit("setSearchForm", i.searchData);
      this.allTableObj.searchObj = i.searchData;
      this.allTableObj.currentTab = "search";
      const reqObj = {
        index: 0,
        size: 20,
        ...i.searchData,
      };
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCancleSeach(i) {
      this.searchVisible = i.searchShow;
    },
    handleDelOne(i) {
      //减少一个检索条件时
      this.searchTagList = this.searchTagList.filter((item, index) => {
        if (item[0] === i[0]) {
          return false;
        } else {
          return true;
        }
      });
      const obj = this.deleteOneSearch(
        i[0],
        this.$store.state.currentSearchForm
      );
      if (this.$baseFunc.paramsValidate(obj)) {
        this.allTableObj.searchDataNow.dataList = [];
        this.allTableObj.searchDataNow.currentPage = 1;
        this.allTableObj.searchDataNow.pageSize = 20;
        this.allTableObj.searchDataNow.total = 0;
        this.allTableObj.currentTab = "all";
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage =
          this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize =
          this.allTableObj.allDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      } else {
        const reqObj = {
          index: 0,
          size: 20,
          ...obj,
        };
        this.pageSearchGet(reqObj, this.allTableObj);
      }
      this.$store.commit("setSearchForm", obj);
    },
    //检索条件或者分页等变化时请求数据
    pageSearchGet(reqobj, obj) {
      const flag = obj.currentTab;
      obj.loadObj.isLoading = true;
      // let endTime = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      // let endObj = {
      //   endtime: this.Utils.dateFormat(endTime, "YYYY-MM-DD"),
      //   starttime: this.Utils.dateFormat(
      //     new Date(endTime.getTime() - 168 * 60 * 60 * 1000),
      //     "YYYY-MM-DD"
      //   ), ...reqobj
      // };
      callRecordApi
        .getList(reqobj)
        .then((res) => {
          if (res.code === 0) {
            if (flag == "all") {
              obj.allDataNow.dataList = res.data.map((o, i) => {
                let a = {
                  ...o,
                  startTime: this.timestampToTime(o.startTime),
                  endTime: this.timestampToTime(
                    o.startTime + o.callDuration * 1000
                  ),
                  establishedTime: o.establishedTime
                    ? this.timestampToTime(o.establishedTime)
                    : "-",
                  releaseTime: o.releaseTime
                    ? this.timestampToTime(o.releaseTime)
                    : "-",
                  num: res.index * res.size + i + 1,
                };
                return a;
              });
              obj.allDataNow.total = res.total;
              obj.fenyeObj.currentPage = obj.allDataNow.currentPage;
              obj.fenyeObj.pageSize = obj.allDataNow.pageSize;
              obj.dataList = obj.allDataNow.dataList;
              obj.fenyeObj.total = obj.allDataNow.total;
              return false;
            } else if (flag == "search") {
              obj.searchDataNow.dataList = res.data.map((o, i) => {
                let a = {
                  ...o,
                  startTime: this.timestampToTime(o.startTime),
                  endTime: this.timestampToTime(
                    o.startTime + o.callDuration * 1000
                  ),
                  establishedTime: o.establishedTime
                    ? this.timestampToTime(o.establishedTime)
                    : "-",
                  releaseTime: o.releaseTime
                    ? this.timestampToTime(o.releaseTime)
                    : "-",
                  num: res.index * res.size + i + 1,
                };
                return a;
              });
              obj.searchDataNow.total = res.total;
              obj.fenyeObj.currentPage = obj.searchDataNow.currentPage;
              obj.fenyeObj.pageSize = obj.searchDataNow.pageSize;
              obj.dataList = obj.searchDataNow.dataList;
              obj.fenyeObj.total = obj.searchDataNow.total;
              return false;
            }
          } else {
            this.$message.error(`请求失败：${res.des}`);
          }
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    handleDetail(i, j) {
      j.contactType = j.contactType == "Inbound" ? "呼入" : "呼出";
      this.routeTo({ path: "/record/recordDetail" });
      sessionStorage.setItem("recordDetail", JSON.stringify(j));
      //   this.routeTo({ path: "/record/recordDetail", query: { gid: j.gid } });
    },
  },
  mounted() {
    this.loadData(this.allTableObj);
  },
};
</script>
<style lang="scss" scoped>
.outDiv {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  padding: 20px;
  display: flex;
  flex-flow: column;
}
.searchBar {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .searchLeft {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
}
.tableContainer > div {
  height: calc(100vh - 410px);
}
</style>
